/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { userAssignRole } from '../../axios/userAssignRole'
import type { UserAssignRoleError, UserAssignRoleRequest, UserAssignRoleResponse } from '../../types/UserAssignRole'

export const userAssignRoleMutationKey = () => [{ url: '/users/assign-role' }] as const

export type UserAssignRoleMutationKey = ReturnType<typeof userAssignRoleMutationKey>

export type UserAssignRoleVariables = {
	data: UserAssignRoleRequest
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/UserController.php UserController::assignRole */
export function useUserAssignRole<TContext = unknown>(
	options?: UseMutationOptions<
		UserAssignRoleResponse,
		AxiosError<UserAssignRoleError>,
		UserAssignRoleVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: userAssignRoleMutationKey(),
		mutationFn: ({ data }: UserAssignRoleVariables) => userAssignRole(data, config).then(res => res.data),
		...options,
	})
}
